module.exports = __webpack_public_path__ + "static/media/loader.88f109ce.svg";